'use client';

import { useTranslation } from 'next-i18next';
import { cn } from '@utils/cn';

interface AddTaskInfoProps {
  className?: string;
}

/**
 * The "what is zmeu" banner behind the Task label in the add-job menus.
 *
 * zmeu is a separate product from bestjobs, so the Task entry needs a sentence of
 * context before someone calls or writes: the icons alone say "phone" and "WhatsApp",
 * not what happens afterwards. Shared by the desktop navbar menu and the mobile
 * bottom bar so the explanation cannot drift between the two.
 *
 * One sentence, no heading and no outbound link — the menu is a decision point, not
 * a place to read about the product. The copy carries a defaultValue fallback so the
 * banner reads correctly before the Localise key lands.
 */
export const AddTaskInfo = ({ className }: AddTaskInfoProps) => {
  const { t } = useTranslation('common');

  return (
    // whitespace-normal: the menu rows are nowrap, and the sentence has to wrap.
    <div className={cn('w-64 whitespace-normal border-t border-ink/5 bg-surface-50 px-4 py-3', className)}>
      <p className="text-sm font-normal leading-snug text-ink-medium">
        {t('label.zmeu.info.description', {
          defaultValue: 'Spune-ne la telefon sau WhatsApp ce taskuri ai, și revenim în scurt timp '
            + 'cu 3-5 specialiști din zona ta. Gratuit.',
        })}
      </p>
    </div>
  );
};
